module.exports = __webpack_public_path__ + "static/media/celebrate.b00ced4b.svg";